import { FC, useMemo } from 'react';
import startCase from 'lodash/startCase';
import upperCase from 'lodash/upperCase';

import { GProduct, Variant } from '@/types';
import { Link, sortVariantByPrice } from '@/components';
import { NOT_DEFINED, TEMPLATE_BASE_PATH } from '@/constants';
import {
  formatSpecialFlowerType,
  formatWeightLabel,
  //stringToSlug,
} from '@/utils';

import { CompoundType } from '../Product/context/ProductContext';

interface IAboutProductProps {
  product: GProduct & { brand_url?: string; category_url?: string };
  compoundList: CompoundType[];
}

const AboutProduct: FC<IAboutProductProps> = ({ product, compoundList }) => {
  const brandName = startCase(product.brand_name || NOT_DEFINED);
  //const category = startCase(product.category || NOT_DEFINED);
  const flowerType = startCase(product?.flower_type || NOT_DEFINED);
  //const subCategory = startCase(product?.subcategory || NOT_DEFINED);
  const hasUnitTierMethod = product.tier_method === 'UNIT';

  /* const flowerTypeTextStyle =
    product?.flower_type === 'cbd' ? upperCase : startCase; */

  const availableWeights = useMemo(
    () =>
      sortVariantByPrice(product?.variants as Variant[])
        .map(elem => formatWeightLabel(elem?.type as string))
        .join(', '),
    [product?.variants],
  );

  return (
    <div className="details__data_product">
      <div className={'details__about_product'}>
        <p className={'details__h3'}>About this product</p>
        <div className={'details__item-about'}>
          <div className={'details__item-column'}>
            <div>
              <strong>Licensed Producer:</strong>{' '}
              {!product?.brand_name && startCase(NOT_DEFINED)}
              {product?.brand_name && (
                <Link
                  aria-label={`Go to ${brandName}`}
                  className="details__link"
                  href={product.brand_url ?? ''}
                  title={brandName}
                >
                  {brandName}
                </Link>
              )}
            </div>
            {/* <div>
              <strong>Category:</strong>{' '}
              {!product?.category && startCase(NOT_DEFINED)}
              {product?.category && (
                <Link
                  aria-label={`Go to ${category}`}
                  className="details__link"
                  href={product.category_url}
                  title={category}
                >
                  {category}
                </Link>
              )}
            </div> */}
            {product?.flower_type ? (
              <div>
                <strong>Flower Type: </strong>
                {product?.flower_type !== 'not specified' ? (
                  <Link
                    aria-label={`Go to ${product?.flower_type}`}
                    className="details__link"
                    href={`${
                      TEMPLATE_BASE_PATH.STRAIN
                    }${formatSpecialFlowerType(product?.flower_type, true)}`}
                    title={flowerType}
                  >
                    {product?.flower_type === 'cbd'
                      ? upperCase(product?.flower_type)
                      : formatSpecialFlowerType(product?.flower_type) || ''}
                  </Link>
                ) : (
                  startCase(product?.flower_type || NOT_DEFINED)
                )}
              </div>
            ) : null}

            {compoundList?.map(({ type, value }) => (
              <p key={`product-about-${type}`}>
                <strong> {type}:</strong>
                {value}
              </p>
            ))}
            {product?.brand_subtype ? (
              <p>
                <strong>Package Info:</strong>
                {product?.brand_subtype}
              </p>
            ) : null}
            {availableWeights &&
            availableWeights !== 'each' &&
            !hasUnitTierMethod ? (
              <div>
                <strong>Available Weights:</strong>
                {availableWeights}
              </div>
            ) : null}
            {/* <div>
              <strong>SubCategory: </strong>
              {product?.subcategory ? (
                <Link
                  aria-label={`Go to ${product?.subcategory}`}
                  // eslint-disable-next-line max-len
                  className="details__link"
                  href={`${product?.category_url}/${stringToSlug(
                    product?.subcategory,
                  )}`}
                  title={subCategory}
                >
                  {flowerTypeTextStyle(product?.subcategory || '')}
                </Link>
              ) : (
                startCase(product?.subcategory || NOT_DEFINED)
              )}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export { AboutProduct };
